import Staff from '@/api/home/staff'
import Homework from '@/api/eschool/homework'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  teacher_id: null,
  homework_status_id: null,
  date_from: moment()
    .add(-2, 'Month')
    .format('DD-MM-YYYY'),
  date_to: moment()
    .add(1, 'Month')
    .format('DD-MM-YYYY')
}

export const getters = {
  getTotalByClass: state => ({ class_id } = {}) => {
    if (class_id !== undefined && state.resources !== undefined) {
      return state.resources.filter(
        h => h.class_id == class_id && h.teacher_id == state.teacher_id
      ).length
    }

    return 0
  },
  getTotalBySubject: state => ({ subject_id } = {}) => {
    if (subject_id !== undefined && state.resources !== undefined) {
      return state.resources.filter(
        h => h.subject_id == subject_id && h.teacher_id == state.teacher_id
      ).length
    }

    return 0
  },
  getTotalByStatus: state => ({ status_id } = {}) => {
    if (status_id !== undefined && state.resources !== undefined) {
      return state.resources.filter(
        h => h.is_sent == status_id && h.teacher_id == state.teacher_id
      ).length
    }

    return 0
  },
  getTotalByHomeworkStatus: state => ({ homework_status_id } = {}) => {
    if (homework_status_id !== undefined && state.resources !== undefined) {
      return state.resources.filter(
        h =>
          h.homework_status_id == homework_status_id &&
          h.teacher_id == state.teacher_id
      ).length
    }

    return 0
  }
}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  RECEIVE_PROFILES(state, data) {
    state.profile = data
  },
  SET_TEACHER_ID(state, data) {
    state.teacher_id = data
  },
  SET_HOMEWORK_STATUS(state, value) {
    state.homework_status_id = value
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    let params = Object.assign({
      page: context.state.pagination.page,
      perPage: context.state.pagination.perPage,
      search: context.state.search,
      date_from: context.state.date_from,
      date_to: context.state.date_to,
      status: context.state.homework_status_id,
      filter: {
        teacher_id: context.state.teacher_id
      },
      ...attributes
    })
    return Homework.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  fetchProfile(context = {}) {
    return Staff.getProfile().then(response => {
      context.commit('RECEIVE_PROFILES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchClassesByTeacher(context = {}) {
    return Staff.getClassByTeacher({
      params: {
        teacher_id: context.state.teacher_id
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },

  fetchSubjectByTeacher(context = {}) {
    return Staff.getSubjectByTeacher({
      params: {
        teacher_id: context.state.teacher_id
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  }
}
